import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';  // Add this import

const firebaseConfig = {
    apiKey: "AIzaSyAQ29KrG5R4VGc_ug5apEeVxijVGvHj3RI",
    authDomain: "balance-57a74.firebaseapp.com",
    databaseURL: "https://balance-57a74-default-rtdb.firebaseio.com",
    projectId: "balance-57a74",
    storageBucket: "balance-57a74.firebasestorage.app",
    messagingSenderId: "739613865744",
    appId: "1:739613865744:web:3e6423acec1c71daf1d795"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);  // Add this export
